export default __webpack_public_path__ + "static/media/cry.b6ace15a.svg";